<template>
<div>

<div class="modal modal-mask" id="productColorList" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true" style="display: block">

  <div class="modal-dialog modal-lg">
    <div class="modal-content">
     <div class="modal-header bg-info text-white"> 
      
      <h4><i class="fas fa-edit mr-2" aria-hidden="true"></i>MODIFICA PREZZO E SCONTO COLORI ID PRODOTTO {{productId}}</h4>

    </div>
  
    <div class="card">
      <div class="card-header">
        CALCOLA SCONTO
      </div>
        <div class="card-body">
        
          <div class="form-inline ml-3">
            
            <div class="form-group">
            
            <label style="color:brown" class="mr-3" for="inputDiscount"><strong>PREZZO DI LISTINO</strong> <span class="badge badge-light ml-3  price">{{ fmt1(price) }}</span></label>
              
            <div class="input-group mb-2">
              <div class="input-group-prepend">
                <div class="input-group-text">% SCONTO</div>
              </div>
              <input type="number" @input="setTotal()" class="form-control " placeholder="% SCONTO" v-model="discount">
              
            </div>            
            <span  class="total ml-3">
              {{ fmt1(total) }}
            </span>
            
            </div>
            
          </div>
        </div>
    </div>

    <form v-on:submit.prevent="saveData()">

  <div class="modal-body">
    
  <div class="table-responsive">   
  <table class="table table-sm">
    <thead class="thead-dark">
      <tr>
       
        <th>
           COLORE
        </th>
        <th>
           PREZZO DI VENDITA
        </th>
        
        <th>
           % SCONTO 
        </th>
        
        
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item,index) in items" :key="index">
        
        <td class="text-nowrap" style="color: black" >
          <strong>{{item.color}}</strong>
        </td>  
        <td>        
          <div class="input-group">
              <div class="input-group-prepend">
                <div v-if="index==0" >
                  <span   @click="repeatPrice(item.price,item.discount)" class="input-group-text pointer" data-toggle="tooltip"  title="Ripeti prezzo per ogni colore"><i class="fas fa-clone " aria-hidden="true"></i></span>                
                </div>
              </div> 
             <input :min="0.00" :step="0.01" required v-model = "item.price" class="form-control form-control-sm  bold "  v-bind:id="'id1_' + index " type="number">
          </div> 
        </td>
        <td>
          <input required :min="0" :max="100" v-model = "item.discount" class="form-control bold"  v-bind:id="'id2_' + index " type="number">          
        </td>

      </tr>
    </tbody>
  </table>
  </div>

  
  <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
  <spinner v-bind:spinner='spinner'></spinner>
 

 <!-- MODAL BODY-->  
 </div>

<!-- FOOTER --> 
<div class="modal-footer">
  <button type="button"  @click="$emit('close')" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
  <button :disabled="items.length==0" type="submit" class="btn btn-primary float-right ">
  <i class="fas fa-save mr-2" aria-hidden="true"></i>
            APPLICA
    <span v-if="spinner"  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  </button>
</div>

</form>
</div>
</div>
</div>
</div> 

</template>

<script>

import api                from "@/api"
import alertBox           from '@/components/common/AlertBox.vue';
import spinner            from '@/components/common/Spinner.vue';
import fmt                from '@/components/mixins/fmt.js'


export default {
   props : ['productId','promoId','price'],
   mixins :[fmt],
   components: {alertBox,spinner},  
  

  data () {
    return {      

      items           : [],
      promoDiscounts  : [],
      promoPrices     : [],    
      msg             : {
        title : ''
      },
      alert           : false,
      spinner         : false,
      discount        : 0,
      total           : 0
      

    }
  },

  created()
  {
      
      this.getData()
  },
  methods: 
  {
    setTotal()
    {
      const total = this.price * this.discount / 100.00
      this.total = this.price - total
    },
    repeatPrice(price,discount)
    {
      this.items.forEach(item=>{
        item.price = price
        item.discount = discount
      })
    },
    async getData()
    {
    
    this.spinner  = true
    
    const data      = {'productId' : this.productId,'promoId':this.promoId}
    const sp        = {'sp' : 'spPromoProductColorList'}
    const json      = Object.assign(data, sp);
    await api.post(json).then(res => {
         
          if(res.status==200)
            {               
              this.items = res.data.recordsets[0]
              this.promoDiscounts = res.data.recordsets[1]
              this.promoPrices = res.data.recordsets[2]

              this.items.forEach(item =>{
               
               this.promoDiscounts.forEach(row=>{
                 if(row.colorId == item.colorId)
                 {
                  
                   item.discount = row.discount
                   
                 }
               })
               this.promoPrices.forEach(row => {
                 if(row.colorId == item.colorId)
                 {
                  
                   item.price = row.price
                   
                 }
               })
                   
             })

              this.$nextTick().then(function () {
              
              document.getElementById("id1_0").focus();
                
               })

            }
           else if(res.status==500)
           {
                
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                
                
                this.msg.title = 'ATTENZIONE '  
                this.msg.body = res
                this.msg.type  = 1
                              
                 
            } 
          

          }).catch(err => {
              
              
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type  = 1
                
              
          }).finally(() => {
          this.spinner = false
        });
  
    
    },
    async saveData()
    {

      this.msg.title = ''

      this.spinner            = true
      const data              = {}
      data.body               = []
      
     
      this.items.forEach(item=>{
        data.body.push({'productId':this.productId,'promoId':this.promoId,'discount':item.discount,'colorId':item.colorId,'price':item.price})   
      })
      
      this.spinner  = true
      
      const sp        = {'sp' : 'spUpdatePromoProduct'}
      const json      = Object.assign(data, sp)

      await api.post(json).then(res => {
          
          if(res.status==200)
            {
                
                this.msg.title = "MODIFICA EFFETTUATA."
                this.msg.type  = 0
            }
           else if(res.status==500)
           {
               
                this.msg.title = 'ATTENZIONE '
                this.msg.body = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                            
                this.msg.title = 'ATTENZIONE '
                this.msg.body = res
                this.msg.type  = 1
                 
            } 

        

          }).catch(err => {
              
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type  = 1   

              
          }).finally(() => {
          this.spinner = false
        });





    }
   
  
  }
  
   
  
}

</script>

<style scoped>
h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
    .bold
    {
        font-weight  : bold;
    }
    
    label{
      color  :  blue
    }
    p {
      font-family  : 'Roboto Condensed';
      font-size    : 25px;
    }
    span {
      font-family  : 'Roboto Condensed';
      font-size    : 15px;
    }
    .price{
      font-family  : 'Roboto Condensed';
      font-size    : 20px;
      
    }
    .total{
      font-family  : 'Roboto Condensed';
      font-size    : 22px;
      color        : green;
      font-weight: bold;
    }
    .pointer{
      cursor: pointer;
    }
    .modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;
}
</style>